import React from 'react';
import { Box, Typography } from '@mui/material';
import ForumIcon from '@mui/icons-material/Forum';
import ConsultationRequestsList from './ConsultationRequestsList';

const ConsultationRequestsPage = () => {
  return (
    <Box>
      <Box px={4} pt={4} pb={2} gap={1} display="flex" alignItems="center">
        <ForumIcon fontSize="large" />
        <Typography variant="h4" fontWeight="bold">
          Richieste di consulenza
        </Typography>
      </Box>

      <ConsultationRequestsList consultantScope="without-consultant" />
    </Box>
  );
};

export default ConsultationRequestsPage;
